import '@adyen/adyen-web/dist/adyen.css';

import {
	completeStage,
	selectStage,
	skipStage,
} from '../../redux/slices/stageSlice';
import { display, selectSession } from '../../redux/slices/sessionSlice';
import { getPaymentMethods, handleAdyenSubmission } from '../../redux/api';
import {
	getReservationFromPMS,
	selectTnc,
} from '../../redux/slices/termsAndConditions';
import { useAppDispatch, useAppSelector } from '../../redux/hook';
import { useEffect, useRef } from 'react';

import AdyenCheckout from '@adyen/adyen-web';
import { CoreOptions } from '@adyen/adyen-web/dist/types/core/types';
import { getNumberOfNightsBetweenDates } from '../../utils';
import Loading from '../../components/loading';
import React from 'react';
import { selectPayment } from './../../redux/slices/paymentSlice';
import { toast } from 'react-toastify';
import useState from 'react-usestateref';
import { DarkButton } from '../../components/dark-button';
import { useTranslation } from 'react-i18next';

export const PaymentContainer = () => {
	const { t } = useTranslation();
	const type = 'dropin';
	const paymentContainer = useRef(null);
	const { skipPayment } = useAppSelector(selectPayment);
	const { reservationDtl, loadingReservation } = useAppSelector(selectTnc);
	const dispatch = useAppDispatch();
	const { token, reservation, propertyInfo } = useAppSelector(selectSession);
	const { stages, stage } = useAppSelector(selectStage);
	//const [TotalPay, setTotalPay] = useState(0.0);
	const [__, setTotalPay, TotalPay] = useState(0.0);

	//parseFloat(reservation?.BalanceAmount) +
	//parseFloat(reservation?.TotalAmount);

	useEffect(() => {
		if (reservation?.PmsConfirmationNo && token) {
			dispatch(
				getReservationFromPMS({
					token,
					confirmationNo: reservation.PmsConfirmationNo,
					propertyCode: propertyInfo?.propertyCode,
				})
			);
			//console.log('after reservation fetch' + TotalPay.current);
		}
	}, [reservation?.PmsConfirmationNo, token]);
	useEffect(() => {
		if (reservationDtl) {
			setTotalPay(
				parseFloat(reservationDtl?.balanceAmount) +
					parseFloat(reservationDtl?.totalAmount)
			);
			//alert(TotalPay + '');
		}
		//console.log('after amount' + TotalPay.current);
	}, [reservationDtl]);
	// const TotalPay =
	// 	parseFloat(reservationDtl?.BalanceAmount) +
	// 	parseFloat(reservationDtl?.TotalAmount);

	const numberOfNights =
		getNumberOfNightsBetweenDates(
			new Date(reservation?.ArrivalDate),
			new Date(reservation?.DepartureDate)
		) ?? 0;

	useEffect(() => {
		if (skipPayment) {
			dispatch(
				skipStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
				})
			);
		}
	}, [skipPayment]);

	const skipPaymentFunc = async () => {
		dispatch(
			skipStage({
				token: token,
				stageID: stage?.stepID,
				ReservationID: reservation?.ReservationID,
				type: 'checkin',
				confirmationNo: reservation?.PmsConfirmationNo,
				stages: stages,
			})
		);
	};

	function handleServerResponse(res: any, component: any) {
		console.log('handleServerResponse', res, res?.action, res?.resultCode);
		if (res?.action) {
			component.handleAction(res.action);
		} else {
			switch (res.resultCode) {
				case 'Authorised':
					if (reservation?.PmsConfirmationNo && stage?.stepID) {
						dispatch(display(true));
						dispatch(
							completeStage({
								token: token,
								stageID: stage?.stepID,
								ReservationID: reservation?.ReservationID,
								type: 'checkin',
								confirmationNo: reservation?.PmsConfirmationNo,
								stages: stages,
								propertyCode: propertyInfo?.propertyCode ?? '', //added new
							})
						);
					}
					break;
				case 'Pending':
				case 'Received':
				case 'Refused':
				case 'Rejected':
				default:
					component.setStatus('ready');
					toast.error(
						'Payment unsuccessful. Please review your payment details and try again.'
					);
					break;
			}
		}
	}

	useEffect(() => {
		console.log('after reservationDtl ' + TotalPay.current);
		if (reservationDtl !== null && reservationDtl != undefined) {
			// const { config, session } = payment;
			let ignore = false;

			// if (!session || !paymentContainer.current) {
			// 	// initiateCheckout is not finished yet.
			// 	return;
			// }
			// const roundedAmount = Math.round(TotalPay.current * 100) / 100;
			const total = parseFloat((TotalPay.current * 100).toFixed(2));
			console.log('after reservationDtl total= ' + total);
			const createCheckout = async () => {
				console.log('createCheckout--' + skipPayment);
				const response = await getPaymentMethods(token);
				console.log('response--' + JSON.stringify(response));

				const configuration: CoreOptions = {
					paymentMethodsResponse: response,
					clientKey: process.env.REACT_APP_ADYEN_CLIENT_KEY,
					locale: 'en_US',
					environment: process.env.REACT_APP_ADYEN_ENVIRONMENT,
					showPayButton: true,
					paymentMethodsConfiguration: {
						card: {
							hasHolderName: true,
							holderNameRequired: true,
							name: 'Credit or Debit Card',
							amount: {
								value: total,
								//value: numberOfNights * (reservation?.RateCodeAmount ?? 0) * 100,
								currency: propertyInfo?.currency ?? '',
							},
						},
					},
					translations: {
						en_US: {
							'creditCard.expiryDateField.title': 'Expiry Date',
							'creditCard.numberField.title': 'Card Number',
							'creditCard.cvcField.title': 'Security Code',
							'creditCard.holderName': 'Name on Card',
						},
					},
					onSubmit: async (state: any, component: any) => {
						if (state.isValid) {
							// const res = await handleAdyenSubmission(
							// 	token,
							// 	{
							// 		paymentPayload: state.data,
							// 		amount:
							// 			numberOfNights * (reservation?.RateCodeAmount ?? 0) * 100,
							// 	},
							// 	'/Payment/SendPayment'
							// );
							const res = await handleAdyenSubmission(
								token,
								{
									paymentPayload: state.data,
									amount: total,
									//numberOfNights * (reservation?.RateCodeAmount ?? 0) * 100,
								},
								'/Payment/SendAdyenPayment',
								reservation?.PmsConfirmationNo
							);
							handleServerResponse(res?.data, component);
						}
					},
					onAdditionalDetails: async (state: any, component: any) => {
						const res = await handleAdyenSubmission(
							token,
							state.data,
							'/Payment/SubmitAdditionalDetails'
						);
						handleServerResponse(res?.data, component);
					},
				};
				const checkout = await AdyenCheckout(configuration);
				// The 'ignore' flag is used to avoid double re-rendering caused by React 18 StrictMode
				// More about it here: https://beta.reactjs.org/learn/synchronizing-with-effects#fetching-data
				// if (paymentContainer.current && !ignore) {
				if (paymentContainer.current && !ignore) {
					checkout.create(type).mount(paymentContainer.current);
				}
				// }
			};

			if (token && reservationDtl) {
				createCheckout();
			}

			return () => {
				ignore = true;
			};
		}
	}, [token, reservationDtl]);

	return skipPayment || loadingReservation === true ? (
		<Loading />
	) : (
		<>
			<div
				id="payment-page"
				className="d-flex flex-column vh-100 mx-auto"
				style={{
					paddingBottom: '110px',
					overflow: 'auto',
				}}>
				<div
					className="d-flex flex-column justify-content-center align-items-center w-100 text-white theme-header"
					style={{ background: '#03355C', minHeight: '80px' }}>
					<h2 className="fs-2 m-0">Payment</h2>
				</div>
				<div
					className="mb-2 mx-auto px-3"
					style={{
						maxWidth: '1200px',
					}}>
					<div ref={paymentContainer} className="payment mt-4 w-100"></div>
				</div>
			</div>
			<div
				className="fixed-bottom d-flex flex-row justify-content-center button-group pb-4 px-2 border-top gap-4 theme-footer"
				style={{
					backgroundColor: 'white',
					borderColor: 'gray',
				}}>
				<DarkButton
					text={t('DocuScanButtonSkip')}
					hideArrow
					onClick={skipPaymentFunc}
					override
				/>
			</div>
		</>
	);
};

// Event handlers called when the shopper selects the pay button,
// or when additional information is required to complete the payment
// async function handleSubmission(state, component, url) {
// 	try {
// 		const res = await sendPostRequest(url, state.data);
// 		handleServerResponse(res, component);
// 	} catch (error) {
// 		console.error(error);
// 		// alert('Error occurred. Look at console for details');
// 	}
// }

// Handles responses sent from your server to the client
